import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Search, X, RotateCcw } from 'lucide-react';

import IconButton from '../../components/ui/IconButton';
import Tooltip from '../../components/ui/Tooltip';

// İzin Bakiye Raporu ve Nakde Çevrilecek İzinler raporunun ortak süzgeç şeridi (2026-10-20). Eskiden kompakt seçiciler
// (34px, etiketsiz) ile etiketli TextInput (40px + üst etiket) yan yanaydı ve hizasızdı. Şimdi her alan kompakt
// seçicinin ölçüsünde: 34px, 1.5px #E0E4E8 kenar, 4px köşe, 13px Nunito Sans; şerit Çalışan Raporları'ndaki gibi kart.
export const FilterCard = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  margin-bottom: 12px;
  background: #fff;
  border: 1.5px solid #E0E4E8;
  border-radius: 10px;
`;

export const FilterField = styled.div`
  width: ${({ $w }) => $w || '220px'};
  max-width: 100%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const SearchBox = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 34px;
  padding: 0 10px;
  border: 1.5px solid #E0E4E8;
  border-radius: 4px;
  background: #fff;
  color: #A0A8B4;
  cursor: text;
  transition: all 0.2s;

  &:hover {
    border-color: #C0C8D0;
  }

  &:focus-within {
    border-color: #0291EF;
    box-shadow: 0 0 0 3px rgba(2, 145, 239, 0.1);
    color: #0291EF;
  }
`;

const SearchText = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 13px;
  color: #004242;

  &::placeholder {
    color: #A0A8B4;
  }
`;

const ClearSearch = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: none;
  background: transparent;
  color: #A0A8B4;
  cursor: pointer;

  &:hover {
    color: #004242;
  }
`;

const Spacer = styled.div`
  flex: 1;
`;

export function SearchField({ value, onChange, placeholder }) {
  const { t } = useTranslation();
  return (
    <SearchBox>
      <Search size={14} />
      <SearchText
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
      />
      {value && (
        <ClearSearch type="button" aria-label={t('leaveBalanceReport.clearSearch')} onClick={() => onChange('')}>
          <X size={14} />
        </ClearSearch>
      )}
    </SearchBox>
  );
}

// Herhangi bir süzgeç doluyken şeridin sağında görünür; hepsini tek tıkla boşaltır.
export function ClearFilters({ visible, onClick }) {
  const { t } = useTranslation();
  if (!visible) return null;
  return (
    <>
      <Spacer />
      <Tooltip text={t('leaveBalanceReport.clearFilters')}>
        <IconButton size="sm" aria-label={t('leaveBalanceReport.clearFilters')} onClick={onClick}>
          <RotateCcw size={15} />
        </IconButton>
      </Tooltip>
    </>
  );
}
